module.exports = __webpack_public_path__ + "img/waves-sm.5e744aae.svg";